import { TEAM_TYPE } from 'constants/ProjectConstants';

export default class OrgTeam {
  constructor({ id, name, userRole, teamType, createdDate, visibilityType, teamEmployees, pendingInvites }) {
    this.id = id;
    this.name = name;
    this.userRole = userRole;
    this.teamType = teamType;
    this.createdDate = createdDate;
    this.visibilityType = visibilityType;
    this.teamEmployees = teamEmployees;
    this.pendingInvites = pendingInvites;
  }

  static fromJSON(json) {
    return new OrgTeam({
      id: json.uuid,
      name: json.name,
      teamType: json.teamType,
      createdDate: json.createdTS,
      visibilityType: json.visibilityType,
      teamEmployees: json.teamEmployees ? json.teamEmployees : [],
      pendingInvites: json.pendingInvites ? json.pendingInvites : [],
    });
  }

  isRoleManager = () => this.userRole && this.userRole === 'MANAGER';

  isPrimaryPod = () => this.teamType === TEAM_TYPE.preferred;
}
